import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_COMMUNITY } from './routes'

export const COMMUNITY_ROUTE_EXPLORE_META = 'community-explore'
export const COMMUNITY_ROUTE_URI_HOME_META = 'community-feed'
export const COMMUNITY_ROUTE_URI_FACET_CONTENT_META = 'community-filtered-{content_type}'
export const COMMUNITY_ROUTE_URI_FACET_DT_IDEA_META = 'community-filtered-dt-idea'
export const COMMUNITY_ROUTE_URI_FACET_DT_POST_META = 'community-filtered-dt-post'
export const COMMUNITY_ROUTE_URI_FACET_IDEA_META = 'community-filtered-idea'
export const COMMUNITY_ROUTE_URI_FACET_MEDIA_META = 'community-filtered-media'
export const COMMUNITY_ROUTE_URI_FACET_QUESTION_META = 'community-filtered-iquestion'
export const COMMUNITY_ROUTE_URI_FACET_WEDO_META = 'community-filtered-wedo'
export const COMMUNITY_ROUTE_URI_FACET_WIKI_META = 'community-filtered-wiki'
export const COMMUNITY_ROUTE_URI_FACET_EXPERIENCE_META = 'community-filtered-experience'
export const COMMUNITY_ROUTE_URI_TERMS_OF_USE_META = 'community-terms-of-use'
export const COMMUNITY_ROUTE_URI_MEMBERS_META = 'community-members'
export const COMMUNITY_ROUTE_URI_SETTINGS_META = 'community-settings'
export const COMMUNITY_ROUTE_URI_REPORTS_META = 'community-reports'
export const COMMUNITY_ROUTE_URI_RECYCLE_BIN_META = 'community-recycle-bin'
export const COMMUNITY_ROUTE_URI_STATISTICS_META = 'community-statistics'

/** @example "/community/explore" */
const COMMUNITY_ROUTE_EXPLORE: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.EXPLORE,
  path: 'explore',
  component: () => import('~/contexts/community/pages/explore.vue'),
  meta: {
    leftNavigation: false,
    name: COMMUNITY_ROUTE_EXPLORE_META,
  },
}

/** @example "/community/[id]" */
const COMMUNITY_ROUTE_URI_HOME: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_HOME,
  path: '',
  component: () => import('~/contexts/community/pages/[thread_id]/index/index.vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_HOME_META,
  },
}

/** @example "/community/[id]/[post|survey]" */
const COMMUNITY_ROUTE_URI_FACET_CONTENT: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_FACETS_CONTENT,
  path: ':content_type',
  component: () => import('~/contexts/community/pages/[thread_id]/index/[content_type].vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_FACET_CONTENT_META,
  },
}

/** @example "/community/[id]/dt-idea-[id]" */
const COMMUNITY_ROUTE_URI_FACET_DT_IDEA: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_FACETS_DT_IDEA,
  path: 'dt-idea-:derived_type_id',
  component: () => import('~/contexts/community/pages/[thread_id]/index/dt-idea-[derived_type_id].vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_FACET_DT_IDEA_META,
  },
}

/** @example "/community/[id]/dt-post-[id]" */
const COMMUNITY_ROUTE_URI_FACET_DT_POST: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_FACETS_DT_POST,
  path: 'dt-post-:derived_type_id',
  component: () => import('~/contexts/community/pages/[thread_id]/index/dt-post-[derived_type_id].vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_FACET_DT_POST_META,
  },
}

/** @example "/community/[id]/idea" */
const COMMUNITY_ROUTE_URI_FACET_IDEA: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_FACETS_IDEA,
  path: 'idea',
  component: () => import('~/contexts/community/pages/[thread_id]/index/idea.vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_FACET_IDEA_META,
  },
}

/** @example "/community/[id]/media" */
const COMMUNITY_ROUTE_URI_FACET_MEDIA: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_FACETS_MEDIA,
  path: 'media',
  component: () => import('~/contexts/community/pages/[thread_id]/index/media.vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_FACET_MEDIA_META,
  },
}

/** @example "/community/[id]/question" */
const COMMUNITY_ROUTE_URI_FACET_QUESTION: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_FACETS_QUESTION,
  path: 'question',
  component: () => import('~/contexts/community/pages/[thread_id]/index/question.vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_FACET_QUESTION_META,
  },
}

/** @example "/community/[id]/wedo" */
const COMMUNITY_ROUTE_URI_FACET_WEDO: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_FACETS_WEDO,
  path: 'wedo',
  component: () => import('~/contexts/community/pages/[thread_id]/index/wedo.vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_FACET_WEDO_META,
  },
}

/** @example "/community/[id]/wiki" */
const COMMUNITY_ROUTE_URI_FACET_WIKI: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_FACETS_WIKI,
  path: 'wiki',
  component: () => import('~/contexts/community/pages/[thread_id]/index/wiki.vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_FACET_WIKI_META,
  },
}

/** @example "/community/[id]/facet-[uri]" */
const COMMUNITY_ROUTE_URI_FACET_EXPERIENCE: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_FACETS_EXPERIENCE,
  path: 'facet-:facet_uri',
  component: () => import('~/contexts/community/pages/[thread_id]/index/facet-[facet_uri].vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_FACET_EXPERIENCE_META,
  },
}

const COMMUNITY_ROUTE_URI_TERMS_OF_USE: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_TERMS_OF_USE,
  path: 'terms-of-use',
  component: () => import('~/contexts/community/pages/[thread_id]/terms-of-use.vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_TERMS_OF_USE_META,
  },
}

/** @example "/community/[id]/[post|idea|wiki|etc...]" */
const COMMUNITY_ROUTE_URI_FACETS: RouteRecordRaw = {
  path: '',
  component: () => import('~/contexts/community/pages/[thread_id]/index.vue'),
  children: [
    COMMUNITY_ROUTE_URI_HOME,
    COMMUNITY_ROUTE_URI_TERMS_OF_USE,
    COMMUNITY_ROUTE_URI_FACET_CONTENT,
    COMMUNITY_ROUTE_URI_FACET_DT_IDEA,
    COMMUNITY_ROUTE_URI_FACET_DT_POST,
    COMMUNITY_ROUTE_URI_FACET_IDEA,
    COMMUNITY_ROUTE_URI_FACET_MEDIA,
    COMMUNITY_ROUTE_URI_FACET_QUESTION,
    COMMUNITY_ROUTE_URI_FACET_WEDO,
    COMMUNITY_ROUTE_URI_FACET_WIKI,
    COMMUNITY_ROUTE_URI_FACET_EXPERIENCE,
  ],
}

/** @example "/community/[id]/members" */
const COMMUNITY_ROUTE_URI_MEMBERS: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_MEMBERS,
  path: 'members',
  component: () => import('~/contexts/community/pages/[thread_id]/members.vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_MEMBERS_META,
  },
}

/** @example "/community/[id]/settings" */
const COMMUNITY_ROUTE_URI_SETTINGS: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_SETTINGS,
  path: 'settings',
  component: () => import('~/contexts/community/pages/[thread_id]/settings.vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_SETTINGS_META,
  },
}

/** @example "/community/[id]/reports" */
const COMMUNITY_ROUTE_URI_REPORTS: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_REPORTS,
  path: 'reports',
  component: () => import('~/contexts/community/pages/[thread_id]/reports.vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_REPORTS_META,
  },
}

/** @example "/community/[id]/recycle-bin" */
const COMMUNITY_ROUTE_URI_RECYCLE_BIN: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_RECYCLE_BIN,
  path: 'recycle_bin',
  component: () => import('~/contexts/community/pages/[thread_id]/recycle-bin.vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_RECYCLE_BIN_META,
  },
}

/** @example "/community/[id]/statistics" */
const COMMUNITY_ROUTE_URI_STATISTICS: RouteRecordRaw = {
  name: ROUTE_COMMUNITY.URI_STATISTICS,
  path: 'statistics',
  component: () => import('~/contexts/community/pages/[thread_id]/statistics.vue'),
  meta: {
    name: COMMUNITY_ROUTE_URI_STATISTICS_META,
  },
}

/** @example "/community/[id]/.*?" */
const COMMUNITY_ROUTES_URI: RouteRecordRaw = {
  path: ':thread_id',
  children: [
    COMMUNITY_ROUTE_URI_FACETS,
    COMMUNITY_ROUTE_URI_RECYCLE_BIN,
    COMMUNITY_ROUTE_URI_MEMBERS,
    COMMUNITY_ROUTE_URI_SETTINGS,
    COMMUNITY_ROUTE_URI_REPORTS,
    COMMUNITY_ROUTE_URI_STATISTICS,
  ],
}

/** Register all community routes as child of "/community" namespace */
export function getRoutes() {
  return [
    COMMUNITY_ROUTE_EXPLORE,
    COMMUNITY_ROUTES_URI,
  ]
}
